<template>
    <svg
        version="1.1"
        id="图层_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1280 720"
        style="enable-background:new 0 0 1280 720;"
        xml:space="preserve"
    >
        <g id="snakeball_00000146460346963740185890000008938139895927930510_">
            <g>
                <circle class="st0" cx="333.8" cy="251.9" r="14" />
                <circle class="st0" cx="364.9" cy="278" r="14" />
                <circle class="st0" cx="387.6" cy="309.9" r="14" />
                <circle class="st0" cx="401" cy="345.4" r="14" />
                <circle class="st0" cx="404" cy="382.6" r="14" />
                <circle class="st0" cx="396" cy="418.6" r="14" />
                <circle class="st0" cx="378.2" cy="450.8" r="14" />
                <circle class="st0" cx="352" cy="477.6" r="14" />
                <circle class="st0" cx="319" cy="497.5" r="14" />
                <circle class="st0" cx="280.7" cy="509.1" r="14" />
                <circle class="st0" cx="238.8" cy="510.6" r="14" />
            </g>

            <ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 14.4108 465.7378)" class="st0" cx="280.9" cy="224.4" rx="28.1" ry="28.1" />
        </g>
        <g>
            <g>
                <circle class="st0" cx="919.1" cy="452.8" r="14" />
                <circle class="st0" cx="872.4" cy="401.8" r="14" />
                <circle class="st0" cx="841.1" cy="325.1" r="14" />
                <circle class="st0" cx="887.5" cy="278" r="14" />
                <circle class="st0" cx="962.2" cy="298.2" r="14" />
                <circle class="st0" cx="1038.9" cy="332.8" r="14" />
                <circle class="st0" cx="1123" cy="334.7" r="14" />
                <circle class="st0" cx="1143.4" cy="266.9" r="14" />
                <circle class="st0" cx="1113.9" cy="186.5" r="14" />
            </g>
            <circle class="st0" cx="966.5" cy="520.5" r="28.1" />
        </g>
        <g>
            <polyline class="st1" points="570.8,430.8 710.2,430.8 671.3,401.2 	" />
            <g>
                <circle class="st2" cx="640.5" cy="333.5" r="43.4" />
                <path
                    class="st3"
                    d="M653.2,345h-14.5c-2.8,0-5.1-2.3-5.1-5.1v-23.7c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1v18.6h9.3
			c2.8,0,5.1,2.3,5.1,5.1S656,345,653.2,345z"
                />
            </g>
        </g>
    </svg>
</template>
     
<style scoped>
.st0 {
    fill: var(--color_back);
}
.st1 {
    fill: none;
    stroke: #8b8b8b;
    stroke-width: 14.5705;
    stroke-miterlimit: 10;
}
.st2 {
    fill: none;
    stroke: #8b8b8b;
    stroke-width: 8.3766;
    stroke-miterlimit: 10;
}
.st3 {
    fill: #8b8b8b;
}
</style>
